import { Box } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import Input from "../../input/input";
import { BuscarCNPJ, ICnpjData } from "../../../buscarCNPJ/buscar-cnpj";

interface PessoaJuridicaFormProps {
  methods: UseFormReturn<any>;
  disabled?: boolean;
  mdDown?: any;
  preencherCampos: (dados: ICnpjData) => void;
}

export function PessoaJuridicaFormPart({
  methods,
  mdDown,
  disabled = false,
  preencherCampos,
}: PessoaJuridicaFormProps) {
  return (
    <Box display="grid" gridTemplateColumns={mdDown ? "1fr" : "1fr 1fr"} gap="20px" width="100%">
      <Box sx={{ gridColumn: mdDown ? "auto" : "1 / -1" }}>
        <BuscarCNPJ onResultado={preencherCampos} methods={methods} />
      </Box>
      <Input
        name="fantasyName"
        label="Nome Fantasia"
        methods={methods}
        disabled={disabled}
      />

      <Input
        name="corporateName"
        label="Razão Social"
        methods={methods}
        disabled={disabled}
      />
    </Box>
  );
}
